import './App.scss';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PrivateRoute from './components/private-router.js';
import AccessRoute from './components/access-router.js';
import Interceptors from './components/axios-interceptors.js';
import Login from './pages/login.js';
import Home from './pages/home.js';
import HostList from './pages/host-list-new.js';
import ManageProfileList from './pages/host-list.js';
import HostGuest from './pages/host-guest.js';
import PodcastSettings from './pages/podcast.js';
import MediaList from './pages/media-list.js';
import UserSettings from './pages/user-settings.js';
import EventList from './pages/event-list.js';
import PastEvents from './pages/event-list-past.js';
import Event from './pages/event.js';
import EpisodeList from './pages/episode-list.js';
import Episode from './pages/episode.js';
import MerchList from './pages/merch-list.js';
import Merch from './pages/merch.js';
import SponsorList from './pages/sponsor-list.js';
import Sponsor from './pages/sponsor.js';
import Profession from './pages/professions.js';
import PodcastCreate from './pages/protected/podcast-create.js';
import PodcastSelect from './pages/protected/podcast-select.js';
import PaymentSuccess from './pages/payment-success.js';
import Billing from './pages/billing.jsx';
import TemplateBuilder from './pages/template-builder.jsx';
import Join from './pages/join.js';
import PodcastJoin from './pages/join-podcast.js';
import ErrorPage from './pages/error.js';
import TemplateList from './pages/template-list.js';

function App() {
    return (
        <BrowserRouter>
            <Interceptors />
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/join" element={<Join />}/>
                <Route path="/join/podcast" element={<PodcastJoin />} />
                <Route path="/payment-success" element={<PaymentSuccess />} />
                <Route path='/' element={<PrivateRoute />}>
                    <Route path='/' element={<Home />} />
                    <Route path='/manage-profiles' element={<ManageProfileList />} />
                    <Route path='/host-list' element={<HostList IsGuest={0} />} />
                    <Route path='/host' element={<HostGuest />} />
                    <Route path='/guest-list' element={<HostList IsGuest={1} />} />
                    <Route path='/guest' element={<HostGuest />} />
                    <Route path='/episode-list' element={<EpisodeList />} />
                    <Route path='/episode' element={<Episode />} />
                    <Route path='/podcast-settings' element={<PodcastSettings />} />
                    <Route path='/settings' element={<UserSettings />} />
                    <Route path='/media' element={<MediaList />} />
                    <Route path='/billing' element={<Billing />} />
                    <Route path='/' element={<AccessRoute />}>
                        <Route path='/template-builder' element={<TemplateBuilder />} />
                        <Route path='/template-list' element={<TemplateList />} />
                        <Route path='/professions' element={<Profession />} />
                        <Route path='/merch-list' element={<MerchList />} />
                        <Route path='/merch' element={<Merch />} />
                        <Route path='/event-list' element={<EventList />} />
                        <Route path='/past-events' element={<PastEvents />} />
                        <Route path='/event' element={<Event />} />
                        <Route path='/sponsor-list' element={<SponsorList />} />
                        <Route path='/sponsor' element={<Sponsor />} />
                        <Route path='/protected'>
                            <Route path='podcast-select' element={<PodcastSelect />} />
                            <Route path='podcast-create' element={<PodcastCreate />} />
                        </Route>
                    </Route>
                </Route>
                <Route path="*" element={<ErrorPage />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
